/**
 * @function
 * @description Initializes the Back to Top button
 */
exports.init = function () {
    var effectSpeed = 500,
        appearenceHeight = 230,
        button = this.createButton();

    button.on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, effectSpeed, function() {
            var $skipLink = $('.skip-link');
            if ($skipLink.length > 0) {
                $skipLink.focus();
            }
        });
    });

    $(window).on('scroll', function() {
        if ($(this).scrollTop() > appearenceHeight) {
            button.fadeIn(effectSpeed);
        } else {
            button.fadeOut(effectSpeed);
        }
    });
};

exports.createButton = function () {
    var button = $('<div/>',{
        'id': 'scrollToTop',
        'role': 'button',
        'tabindex': '0',
        'class': 'scroll-to-top bticons-up',
        'aria-label': 'Back to top',
        'text': ''
    });

    button.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    $('body').append(button);
    return button;
};
